export enum DiscoveryErrorDescription {
    DomainNotAssociated = "DomainNotAssociated",
    UserAlreadyConnected = "UserAlreadyConnected",
    AuthenticationError = "AuthenticationError",
    EmailDisabled = "EmailDisabled",
    NotCompanyEmail = "NotCompanyEmail",
    Other = "Other"
}